(() => {
  if (window.__htCartDrawerInitialized) return;
  window.__htCartDrawerInitialized = true;
  let cartRequest = null;
  let cartRefreshQueued = false;
  let cartVersion = 0;
  const HEADER_CART_TRIGGERS = '.ht-mobile__cart, .ht-actions .ht-action[href*="/cart"]';
  const AJAX_FORMS = 'form.rvp__form, form.ht-shelf__form';
  let countSyncTimer = null;

  const getDrawer = () => document.querySelector('m-cart-drawer');

  const drawerReady = () => {
    const drawer = getDrawer();
    return Boolean(
      drawer &&
      window.MinimogSettings?.enable_cart_drawer &&
      typeof drawer.open === 'function'
    );
  };

  const applyCustomHeaderCount = (itemCount) => {
    const count = Math.max(0, Number(itemCount) || 0);

    document.querySelectorAll(HEADER_CART_TRIGGERS).forEach((link) => {
      let badge = link.querySelector('.ht-cart-count');

      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'ht-cart-count';
          link.appendChild(badge);
        }
        if (badge.textContent !== String(count)) badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
    });
  };

  const refreshCustomHeaderCount = () => {
    if (cartRequest) {
      cartRefreshQueued = true;
      return cartRequest;
    }
    const requestVersion = cartVersion;
    cartRequest = (async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store',
        });
        if (!response.ok) return;
        const cart = await response.json();
        if (requestVersion !== cartVersion) return;
        applyCustomHeaderCount(cart.item_count);
        renderDiscountLabels(cart);
      } catch (error) {
        console.error('[HT Cart Drawer] Unable to refresh cart:', error);
      } finally {
        cartRequest = null;
        if (cartRefreshQueued || requestVersion !== cartVersion) {
          cartRefreshQueued = false;
          scheduleCustomHeaderCountRefresh();
        }
      }
    })();
    return cartRequest;
  };

  const scheduleCustomHeaderCountRefresh = () => {
    cartVersion += 1;
    window.clearTimeout(countSyncTimer);
    countSyncTimer = window.setTimeout(refreshCustomHeaderCount, 100);
  };

  const syncCountFromCartEvent = (event) => {
    cartVersion += 1;
    const itemCount = event?.detail?.cart?.item_count;
    if (itemCount !== undefined && itemCount !== null) {
      applyCustomHeaderCount(itemCount);
      if (Array.isArray(event.detail.cart.items) && event.detail.cart.total_discount != null) {
        renderDiscountLabels(event.detail.cart);
      } else {
        scheduleCustomHeaderCountRefresh();
      }
    } else {
      scheduleCustomHeaderCountRefresh();
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(HEADER_CART_TRIGGERS);
    if (!trigger || !drawerReady()) return;

    event.preventDefault();
    getDrawer().open(trigger);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest(AJAX_FORMS);
    if (!form || !drawerReady()) return;

    if (form.dataset.htCartLoading === 'true') {
      event.preventDefault();
      return;
    }

    event.preventDefault();

    const drawer = getDrawer();
    const formData = new FormData(form);
    const id = formData.get('id');
    const quantity = Math.max(1, parseInt(formData.get('quantity') || '1', 10) || 1);

    if (!id) return;

    form.dataset.htCartLoading = 'true';

    const submitters = [...form.querySelectorAll('[type="submit"]')];
    const previousDisabled = submitters.map((button) => button.disabled);
    submitters.forEach((button) => {
      button.disabled = true;
    });

    try {
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', {
          bubbles: true,
          detail: { sections },
        })
      );

      const data = {
        items: [{ id, quantity }],
        sections,
        sections_url: window.location.pathname,
      };

      const config = typeof window.fetchConfig === 'function'
        ? window.fetchConfig('javascript')
        : {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
          };

      config.method = 'POST';
      config.body = JSON.stringify(data);

      const cartAddUrl =
        window.MinimogSettings?.routes?.cart_add_url ||
        `${window.Shopify?.routes?.root || '/'}cart/add.js`;

      const response = await fetch(cartAddUrl, config);
      const result = await response.json();

      if (!response.ok || result.status) {
        const message =
          result.description ||
          result.message ||
          'Unable to add this item to the cart.';

        if (window.MinimogTheme?.Notification) {
          window.MinimogTheme.Notification.show({
            target: drawer.querySelector('m-cart-items') || document.body,
            method: 'prepend',
            type: 'warning',
            message,
            delay: 3000,
          });
        } else {
          console.error('[HT Cart Drawer]', message);
        }

        document.dispatchEvent(
          new CustomEvent('product-ajax:error', {
            detail: { errorMessage: message },
          })
        );
        return;
      }

      if (window.MinimogEvents && window.MinimogTheme?.pubSubEvents?.cartUpdate) {
        window.MinimogEvents.emit(
          window.MinimogTheme.pubSubEvents.cartUpdate,
          { cart: result }
        );
      }

      if (window.MinimogTheme?.Notification && window.MinimogStrings?.itemAdded) {
        window.MinimogTheme.Notification.show({
          target: drawer.querySelector('m-cart-items'),
          method: 'prepend',
          type: 'success',
          message: window.MinimogStrings.itemAdded,
          delay: 400,
        });
      }

      drawer.open(event.submitter || form.querySelector('[type="submit"]'));

      document.dispatchEvent(
        new CustomEvent('product-ajax:added', {
          detail: { product: result },
        })
      );

    } catch (error) {
      console.error('[HT Cart Drawer] Add to cart failed:', error);
    } finally {
      delete form.dataset.htCartLoading;
      submitters.forEach((button, index) => {
        button.disabled = previousDisabled[index];
      });
    }
  });

  document.addEventListener('cart:updated', syncCountFromCartEvent);
  document.addEventListener('cart:refresh', scheduleCustomHeaderCountRefresh);
  document.addEventListener('product-ajax:added', scheduleCustomHeaderCountRefresh);

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) scheduleCustomHeaderCountRefresh();
  });

  const DRAWER_SELECTOR = '#MinimogCartDrawer';

  const cleanLabel = (value) =>
    String(value || '')
      .replace(/\s*\(-[^)]*\)\s*$/, '')
      .trim();

  const collectDiscountLabels = (cart) => {
    const labels = [];
    const seen = new Set();

    const add = (value) => {
      const label = cleanLabel(value);
      if (!label) return;
      const key = label.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      labels.push(label);
    };

    (cart?.cart_level_discount_applications || []).forEach((discount) => {
      const title = discount?.title || discount?.code;
      const percentage =
        discount?.value_type === 'percentage' && Number(discount?.value) > 0
          ? `${Number(discount.value)}% OFF`
          : '';

      if (title && percentage && !String(title).includes('%')) {
        add(`${title} · ${percentage}`);
      } else {
        add(title || percentage);
      }
    });

    (cart?.items || []).forEach((item) => {
      (item?.discounts || []).forEach((discount) => {
        add(discount?.title || discount?.code);
      });
    });

    document
      .querySelectorAll(
        `${DRAWER_SELECTOR} [data-minimog-cart-discounts] .m-cart__discount--item span`
      )
      .forEach((node) => add(node.textContent));

    return labels;
  };

  const renderDiscountLabels = (cart) => {
    const savingsRow = document.querySelector(
      `${DRAWER_SELECTOR} .ht-cart-summary__row--saving`
    );
    const label = savingsRow?.querySelector('.ht-cart-summary__label');
    if (!label) return;

    const existing = label.querySelector('.ht-cart-summary__discounts');
    const savings = Number(cart?.total_discount || 0);

    if (savings <= 0) {
      existing?.remove();
      return;
    }

    const labels = collectDiscountLabels(cart);
    if (!labels.length) labels.push('Discount applied');

    const signature = labels.join('|');
    if (existing?.dataset.discountKeys === signature) return;
    existing?.remove();

    const list = document.createElement('span');
    list.className = 'ht-cart-summary__discounts';
    list.dataset.discountKeys = signature;

    labels.slice(0, 3).forEach((text) => {
      const chip = document.createElement('span');
      chip.className = 'ht-cart-summary__discount-chip';
      chip.textContent = text;
      list.appendChild(chip);
    });

    label.appendChild(list);
  };

  const scheduleRefresh = scheduleCustomHeaderCountRefresh;

  const start = () => {
    scheduleRefresh();
    const drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer) return;

    const observer = new MutationObserver((records) => {
      const hasExternalChange = records.some((record) => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target?.closest('.ht-cart-summary__discounts')) return false;
        const nodes = [...record.addedNodes, ...record.removedNodes];
        return !nodes.length || !nodes.every((node) =>
          node.nodeType === 1 && node.matches('.ht-cart-summary__discounts')
        );
      });
      if (hasExternalChange) scheduleRefresh();
    });
    observer.observe(drawer, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

})();
